import React, { ReactElement } from 'react';
import { KodanshaNewsWheel } from '../KodanshaNewsWheel/KodanshaNewsWheel';
import { Link } from '../../Devon/Components/InkyLink';
import KodanshaArrow from '../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import './NewsWheelStrip.scss';

export function NewsWheelStrip(): ReactElement {
    return (
        <section className='NewsWheelStrip'>
            <KodanshaNewsWheel title='Recent news' />
            <Link to={'/news'} onClick={(e): void => {
                e.stopPropagation();
            }}>
                <KodanshaArrow text='View more' withArrow />
            </Link>
        </section>
    );
}
